import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    component: () => import('@/layouts/home/Index.vue'),
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/views/home/Index.vue'),
        meta: {
          key: 'home'
        }
      },
      {
        path: '/about',
        name: 'About',
        component: () => import('@/views/about/Index.vue'),
          meta: {
          key: 'about'
        }
      },
      {
        path: '/contact-us',
        name: 'Contact',
        component: () => import('@/views/contact-us/Index.vue'),
          meta: {
          key: 'contact'
        }
      },
      {
        path: '/projects',
        name: 'Projects',
        component: () => import('@/views/projects/Index.vue'),
          meta: {
          key: 'projects'
        }
      },
      {
        path: '/offer/:section',
        props: {
          setion: String
        },
        name: 'Offer',
        component: () => import('@/views/offer/Index.vue'),
          meta: {
          key: 'offer'
        }
      },
      {
        path: '*',
        name: 'FourOhFour',
        component: () => import('@/views/404/Index.vue'),
          meta: {
          key: '404'
        }
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
